import GenericForm from 'components/GenericForm';
import type { GenericFormFields, SitecoreBlockProps } from 'models/sitecore';

interface Props extends SitecoreBlockProps {
	fields?: GenericFormFields;
}

export default function GenericFormBlock({ fields }: Props) {
	if (!fields) {
		return null;
	}

	return (
		<GenericForm
			formLocation={fields.formName.value}
			sections={fields.sections}
			errorView={fields.error}
			successView={fields.success}
			loadingView={fields.loading}
		/>
	);
}
GenericFormBlock.displayName = 'GenericForm';
